import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  status: undefined, // required, enum(new, processing, sent, error) - Trạng thái
  source: undefined, // optional - Nguồn gửi. Chi tiết xem trong: https://docs.google.com/spreadsheets/d/1EHw3No1SLpw86AnaIdpyxmEMMRIAQn-mEzse3z3kuxg/edit
  fromUserId: undefined, // required, ref: mushroom_user - Mã người dùng
  fromUserName: undefined,
  dong_ho_id: undefined, // required, ref: dong_ho - Mã dòng họ sẽ nhận được thông báo
  title: undefined, // required - Tiêu đề tin nhắn
  message: undefined, // required - Nội dung tin nhắn
  priority: undefined, // optional, enum(normal, high) - Mức độ ưu tiên
  schedule: undefined, // required - Thời điểm gửi
  imageId: undefined, // optional, ref: mushroom_file - Mã file
  anh_url: undefined,
  anh_btn_show: undefined,
  createdTime: undefined, // required - Thời điểm tạo
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-createdTime",
  defaultSort: ["createdTime", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      status: "",
      title: "",
      dong_ho_id: "",
    },
    valid: {
      createdTime: []
    },
    operator: {
      status: ":regex_i:",
      title: ":regex_i:",
      dong_ho_id: "",
    },
  },
};

export default model;
